import type { BusinessModel } from "app/pages/sales-intelligence/domain/leads/types/enums";
import { CheckboxFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/filters/CheckboxFilter/CheckboxFilter";
import { CheckboxFilterResult } from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/filters/CheckboxFilter/CheckboxFilterResult";
import { CheckboxFilterModel } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/CheckboxFilterModel";

import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { defineDescriptionFilter } from "../defineSourcedFilter";

export const businessModelsDefinition = defineDescriptionFilter({
    key: "businessModels",
    apiCategory: leadsFilterApiCategory.businessModels,
    category: leadsFilterCategoryMap.company,
    trackingName: "Business Model",
    titleKey: { key: "si.lead_gen_filters.businessModel.name" },

    render: ({ description }) => ({
        tooltipText: { key: "si.lead_gen_filters.group.businessModel.tooltip" },
        filter: new CheckboxFilterModel<BusinessModel>(
            description.businessModels,
            "si.lead_gen_filters.businessModels",
        ),
        filterView: CheckboxFilter<BusinessModel>,
        filterResultView: CheckboxFilterResult<BusinessModel>,
    }),
});
